export class ReviewSet {
	public id: string;
	public caseId: string;
	public isActive: boolean;
	public status: 'pre-review' | 'reviewing' | 'post-review'
	public documentsInReview: number;
	public remainingDocuments: number;
	public reviewedDocuments: number;
	public totalDocuments: number;
	public name: string;
	public lockedDocument: string;
	public reviewOrder: 'master-date' | 'source-file-path';

}
